// src/app/lib/smsSendErrors.ts

export type SendSmsFailure = { ok: false; skipped?: boolean; reason: string }

/**
 * Translate sendSms mutation error codes into human copy. Consent and quiet-hour
 * rejections are deliberate skips, not failures, so callers bucket them separately.
 */
export function classifySendSmsFailure(message: string, code?: string): SendSmsFailure {
  if (code === `OPTED_OUT`) {
    return { ok: false, skipped: true, reason: `Opted out of texts from this location` }
  }
  if (code === `INVALID_PHONE`) {
    return { ok: false, reason: `Invalid phone number` }
  }
  if (code === `THROTTLED`) {
    return { ok: false, reason: `Sending is throttled — try again in a few minutes` }
  }
  if (code === `LOCATION_NOT_CONFIGURED`) {
    return { ok: false, reason: `This location's texting number is not set up — check its phone number settings` }
  }
  if (code === `QUIET_HOURS`) {
    return { ok: false, skipped: true, reason: `Quiet hours at this practice (8pm-8am)` }
  }
  return { ok: false, reason: message.replace(/^\[GraphQL\]\s*/, ``) }
}
